<div class="row-md-12 align-items-center p-2 mb-2 bg-white" (click)="selected(model.code)">
  <img src="{{model.imageUrl}}" width="100%" height="200" style="object-fit:contain;">
  <div class="p-3">
    <span>{{model.title}}</span>
  </div>
  <div class="p-3">
    <span class="fs2 f-orange">{{model.minPriceWithDisCount}} - {{model.maxPriceWithDisCount}}</span>
  </div>
</div>